'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';
const TextInput = /*#__PURE__*/forwardRef(function ForwardedTextInput(props, forwardedRef) {
  const {
    className,
    error,
    fullWidth,
    rounded,
    type = 'text',
    placeholder,
    label,
    value,
    ...rest
  } = props;
  const focusClasses = 'focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-20 transition-shadow';
  const errorFocusClasses = 'focus:border-red-500 focus:ring focus:ring-red-500 focus:ring-opacity-20 transition-shadow';
  const classes = twMerge(className, 'form-input', 'border border-solid border-gray-400 disabled:bg-gray-200 disabled:border-gray-200', error ? errorFocusClasses : focusClasses, rounded ? 'px-5 py-2 rounded-full' : 'p-2 rounded', fullWidth && 'block w-full');
  const id = (label || placeholder || '').replace(/\s/g, '-');
  const [passwordShown, setPasswordShown] = useState(false);
  const isPassword = (type === null || type === void 0 ? void 0 : type.toLowerCase()) === 'password';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: "text-base font-semibold block"
  }, label || placeholder), isPassword && /*#__PURE__*/React.createElement("a", {
    role: "button",
    tabIndex: 0,
    className: "no-underline text-right cursor-pointer leading-loose font-semibold text-sm",
    onClick: () => setPasswordShown(passwordShown => !passwordShown),
    onKeyDown: () => setPasswordShown(passwordShown => !passwordShown)
  }, passwordShown ? 'Hide Password' : 'Show Password')), /*#__PURE__*/React.createElement("input", _extends({
    id: id,
    className: classes,
    type: passwordShown ? 'text' : type,
    placeholder: placeholder,
    ref: forwardedRef,
    value: value
  }, rest)));
});
export default TextInput;